export default __webpack_public_path__ + "static/media/06_OrangeBlueAndBlack.c2c72970.png";